import { getLinkStyles } from 'app/components/presentation/link/styles';
import Link, { ILinkProps } from 'app/components/router/Link';
import { useClasses } from 'app/utils/css';
import React from 'react';

const WrappedLink: React.FunctionComponent<ILinkProps> = (props) => {
  const classes = useClasses({
    link: getLinkStyles(),
  });

  return (<Link className={classes.link} {...props} />);
};

export default WrappedLink;
